import { concatMap, map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../tokens/is-browser.token";
import * as i3 from "./server-config.service";
import * as i4 from "../../web-generator/template-generator/service/template.service";
import * as i5 from "../../web-generator/template-generator/service/cms-module-resolver.service";
/** 應用主題模板判斷是否重新載入畫面 */
export class TemplateApplyGuardService {
    constructor(route, router, isBrowser, serverConfigService, templateService, cmsModuleResolver) {
        this.route = route;
        this.router = router;
        this.isBrowser = isBrowser;
        this.serverConfigService = serverConfigService;
        this.templateService = templateService;
        this.cmsModuleResolver = cmsModuleResolver;
    }
    canActivate(route, state) {
        let applyTemplate = route.data.applyTemplate;
        // if (this.router.url === '/') { // 根目錄，是第一次 route guard 執行
        //   return true;
        // }
        //如果是cms先判斷是否為新版型的cms(normal-03、partner-01)
        const isCmsPath = route.data.isCms;
        const source$ = isCmsPath
            ? this.cmsModuleResolver.resolve(route, state).pipe(concatMap((cmsMeta) => {
                // 根據 cmsMeta 設定 applyTemplate
                if (cmsMeta && cmsMeta.moduleKey === "NORMAL" && cmsMeta.template === "03") {
                    //新cms依照後台設定版型，直接進行下一步
                }
                else if (cmsMeta && cmsMeta.moduleKey === "PARTNER" && cmsMeta.template === "01") {
                    //新cms依照後台設定版型，直接進行下一步
                }
                else if (cmsMeta && cmsMeta.moduleKey === "WEB" && cmsMeta.template === "02") {
                    //新cms依照後台設定版型，直接進行下一步
                }
                else if (cmsMeta) {
                    //舊cms使用舊版型template-040
                    applyTemplate = "template-040";
                }
                else {
                    // 不存在的 CMS 路徑，到瀏覽器會轉去404頁，直接進行下一步
                }
                return this.serverConfigService.getConfig$();
            }))
            : this.serverConfigService.getConfig$(); //若不是cms型直接往下執行
        return source$.pipe(map((siteInfo) => siteInfo.templateKey || "template-040"), // 後台設定要套用的模板 key
        map((defaultTemplate) => {
            if (!applyTemplate) {
                applyTemplate = defaultTemplate;
            } // 路由上沒設定要套用的模板就預設和後台挑的模板設定一致
            if (!this.lastApplyTemplate) { // 沒有上一個模板，是第一次 route guard 執行，不需要檢查模板一致的問題，直接設定模板
                this.lastApplyTemplate = applyTemplate;
                // if (applyTemplate !== defaultTemplate) { // 要套用的模板和後台模板設定的不同
                this.templateService.setTemplateKey(applyTemplate);
                // }
                return true;
            }
            if (applyTemplate !== this.lastApplyTemplate) { // CSR 切換頁面時發現要套用的模板不同，就重新載入頁面
                if (this.isBrowser) {
                    location.href = `${this.serverConfigService.origin}${state.url}`;
                    return false;
                }
            }
            this.lastApplyTemplate = applyTemplate;
            return true;
        }));
    }
}
TemplateApplyGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TemplateApplyGuardService_Factory() { return new TemplateApplyGuardService(i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.IS_BROWSER_TOKEN), i0.ɵɵinject(i3.ServerConfigService), i0.ɵɵinject(i4.TemplateService), i0.ɵɵinject(i5.CmsModuleResolverService)); }, token: TemplateApplyGuardService, providedIn: "root" });
